<template>
  <div class="text-danger px-2" data-test="dynamicFieldError">
    <small v-for="(error, index) of errors" :key="index" class="d-block">
      {{ error.$message }}
    </small>
  </div>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      default: () => [],
    },
  },
}
</script>
